<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 17:53:15
 * @LastEditTime: 2019-08-15 11:08:04
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div>
     <el-tabs v-model="activeName" type="card"  @tab-click="handleClick">
          <el-tab-pane label="门店库存统计（门店）" name="2">
            <el-form ref="form" :model="form" label-width="120px" :inline="true">
              <el-form-item label="门店信息:" prop="to_sn">
                <el-col :span="18">
                  <el-input v-model="form.to_sn"  class="readonlyclass"></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                  <el-button type="primary" @click='selectRoleDialog=true'>选择</el-button>
                </el-col>
              </el-form-item>
               <el-form-item label="关键词:">
                <el-input v-model="form.keywords" clearable ></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 100px">
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button type="primary" @click="onExport()">导出</el-button>
              </el-form-item>
            </el-form>
            <div style="padding-left:50px">
              库存总数:
              <span style="color:#f04635">{{total}}</span>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column  label="序号" fixed><template slot-scope="scope">{{scope.$index}}</template></el-table-column>
              <el-table-column prop='to_name' label="门店名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop='to_sn' label="门店编号" show-overflow-tooltip></el-table-column>
              <el-table-column prop='to_level_name' label="门店类型" show-overflow-tooltip></el-table-column>

              <el-table-column prop='stock_total' label="库存数量" show-overflow-tooltip></el-table-column>

              <el-table-column prop label="操作" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='detail(scope.row)'>明细</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="门店库存统计(产品)" name="3">
            <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                <el-form-item label="门店信息:" prop="to_sn">
                <el-col :span="18">
                  <el-input v-model="form1.to_sn"  class="readonlyclass"></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                  <el-button type="primary" @click='selectRoleDialog=true'>选择</el-button>
                </el-col>
              </el-form-item>
               <el-form-item label="关键词:">
                <el-input v-model="form1.keywords" clearable ></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 100px">
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button type="primary" @click="onExport()">导出</el-button>
              </el-form-item>
            </el-form>
            <div style="padding-left:50px">
              库存总数:
              <span style="color:#f04635">{{total}}</span>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed><template slot-scope="scope">{{scope.$index}}</template></el-table-column>
              <el-table-column prop='product_sn' label="产品编号" show-overflow-tooltip></el-table-column>
              <el-table-column prop='product_name' label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop='product_specs' label="产品规格" show-overflow-tooltip></el-table-column>
              <el-table-column prop='stock_total' label="库存数量" show-overflow-tooltip></el-table-column>
              <el-table-column prop='' label="操作" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='detail(scope.row)'>明细</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
            <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getSelectinfo">
        </selectRole>
          <el-dialog
                :visible.sync="detailDialog"
                width="40%"
                title='查看明细'
                 v-on:handleClose='detailDialog = false,pageSize2=20,pageNo2=1'
                >
                      <el-button  size="small" @click="exportDetail()" style='margin-bottom:10px;'>导出明细</el-button>
            <el-table
                  :data="tableData2"
                  style="width: 100%"
                  border
                    v-loading="loading"
                 >
                           <el-table-column
                                  prop="product_sn"
                                  label="产品编号"
                                  v-if='activeName==2'

                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="product_name"
                                  label="产品名称"
                                  v-if='activeName==2'

                                >
                          </el-table-column>
                          <el-table-column
                                  prop="product_specs"
                                  label="产品规格"
                                  v-if='activeName==2'
                                 
                                 >
                          </el-table-column>
                              <el-table-column
                                  prop="stock_total"
                                  label="剩余数量"
                                  v-if='activeName==2'

                                >
                          </el-table-column>

                              <el-table-column
                                  prop="to_sn"
                                  label="门店编号"
                                  v-if='activeName==3'

                                >
                          </el-table-column>
                          <el-table-column
                                  prop="to_name"
                                  label="门店名称"
                                  v-if='activeName==3'
                                 
                                 >
                          </el-table-column>
                             <el-table-column
                                  prop="to_level_name"
                                  label="门店类型"
                                  v-if='activeName==3'
                                 
                                 >
                          </el-table-column>
                           <el-table-column
                                  prop="stock_total"
                                  label="库存数量"
                                  v-if='activeName==3'

                                  show-overflow-tooltip>
                          </el-table-column>
                        
                    </el-table>
                                   <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
                    </el-dialog>
    </div>
</template>

<script>
    import selectRole from '@/common/selectStore';

export default {
    name:'my',
    data(){
        return{
            selectRoleDialog:false,
                form1:{
                    to_sn:""
                    ,keywords:""
                },
                form:{to_sn:"",keywords:""},
                activeName:'2',
                  loading:false,
                     pageNo1: 1,
                pageSize1: 20,
                totalSize1: 0,
                tableData:[],
                tableData1:[],
                tableData2:[],
                total:0,
                      pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                    pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,
                detailDialog:false,
                detailData:{}
        }
    },
    methods:{
        onSearch(){
            this.loading=true
            if(this.activeName==2){
                    this.$get('logistics','/stocks.child.shops',{
                        ...this.form,
                        per_page:this.pageSize,
                        page:this.pageNo
                    }).then(res=>{
                    this.totalSize=res.meta.total
                    this.tableData=res.data
                    this.total=res.real_stock_out_num
                    this.loading=false
                })
            }else{
                       this.$get('logistics','/stocks.child.shops.products',{
                        ...this.form,
                           per_page:this.pageSize1,
                        page:this.pageNo1
                    }).then(res=>{
                    this.totalSize1=res.meta.total
                    this.tableData1=res.data
                    this.total=res.real_stock_out_num

                    this.loading=false
                })
            }
        },
        onExport(){
                      let url = '',access_tokens = localStorage.getItem('access_token');
                    if(this.activeName==2){
                  
                          window.open(process.env.VUE_APP_URL
                        +'/stocks.child.shops.export'+
                        '?to_sn='+this.form.to_sn+
                        '&keywords='+this.form.keywords+
                       '&lang=' + '' +'&is_export=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }else{
          
                          window.open(process.env.VUE_APP_URL
                        +'/stocks.child.shops.products.export?'+
                        'to_sn='+this.form1.to_sn+
                        '&keywords='+this.form1.keywords+
                       '&lang=' + '' +'&is_export=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }
        
        },
        detail(data){
                this.detailDialog=true
        if(data){
            this.detailData=data
        }
                        this.loading=true
                        this.tableData2=[]
            if(this.activeName==2){
                    this.$get('logistics','/stocks.child.shops/datas',{
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        to_sn:this.detailData.to_sn,
                    }).then(res=>{
                        this.tableData2=res.data
                        this.totalSize2=res.meta.total
                        this.loading=false
                    })
            }else{
                     this.$get('logistics','/stocks.child.shops.products/datas',{
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        product_sn :this.detailData.product_sn 
                    }).then(res=>{
                        this.tableData2=res.data
                        this.totalSize2=res.meta.total
                        this.loading=false
                    })
            }
        },
        exportDetail(){
               let url = '',access_tokens = localStorage.getItem('access_token');
    
                    if(this.activeName==2){
                         window.open(process.env.VUE_APP_URL
                        +'/stocks.child.shops/datas.export?'+
                        'to_sn='+this.detailData.to_sn +
                       '&lang=' + '' +'&is_export=1'
                       +'&signature='+this.$md5(access_tokens)
                    )
                    }else{
                             window.open(process.env.VUE_APP_URL
                        +'/stocks.child.shops.products/datas.export?'+
                        'product_sn='+this.detailData.product_sn +                      
                       '&lang=' + '' +'&is_export=1'
                       +'&signature='+ this.$md5(access_tokens)
                    )
                    }
        },
        getSelectinfo(val){
            if(this.activeName==2){
                 if (val.dealer_sn) {
                        this.form.to_sn = val.dealer_sn;
                        this.form.to_type = 2;
                    } else {
                        this.form.to_sn = val.shop_sn;
                        this.form.to_type = 3;
                    }
            }else{
                 if (val.dealer_sn) {
                        this.form1.to_sn = val.dealer_sn;
                        this.form1.to_type = 2;
                    } else {
                        this.form1.to_sn = val.shop_sn;
                        this.form1.to_type = 3;
                    }
            }
        },
                  handleSizeChange1(val) {
            this.pageSize1 = val;
            this.pageNo1 = 1;
            this.onSearch();
        },
        handleCurrentChange1(val) {
            this.pageNo1 = val;
            this.onSearch();
        },
         handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.onSearch();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.onSearch();
        },
            handleSizeChange2(val) {
            this.pageSize2 = val;
            this.pageNo2 = 1;
            this.detail();
        },
        handleCurrentChange2(val) {
            this.pageNo2 = val;
            this.detail();
        },
        handleClick(){
            this.onSearch()
        }
    },
    created(){

           this.onSearch()
    },
    components:{
        selectRole
    }
}
</script>

